import { Link } from "react-router-dom";
import seedMix from "assets/bird_seed.png";
import birdCage from "assets/bird_cage.png"
import birdImage from "assets/bird_product.png"
interface Product {
  id: number;
  name: string;
  price: string;
  originalPrice: string | null;
  image: string;
  isEmoji: boolean;
  description: string;
  badge: string;
}

const featuredProducts: Product[] = [
  {
    id: 1,
    name: "Mysher Seed Mix",
    price: "₱149.99",
    originalPrice: "₱250.99",
    image: seedMix,
    isEmoji: false,
    description: "Nutritious blend of seeds for all bird types",
    badge: "Best Seller",
  },
  {
    id: 2,
    name: "Variety of Birds",
    price: "",
    originalPrice: null,
    image: birdImage,
    isEmoji: false,
    description: "Complete veterinary health examination",
    badge: "Service",
  },
  {
    id: 3,
    name: "Bird Cage",
    price: "₱1,499.99",
    originalPrice: "₱2,899.99",
    image: birdCage,
    isEmoji: false,
    description: "Spacious cage with premium accessories",
    badge: "20% Off",
  },
];

const FeaturedProducts = () => {
  return (
    <section className="bg-gradient-to-br from-[#f8f9fa] to-[#e9ecef] py-16 max-[768px]:mt-12 max-[768px]:py-10 max-[480px]:mt-8 max-[480px]:py-8">
      <div className="container">
        <div className="mb-12 text-center max-[768px]:mb-8">
          <h2 className="mb-4 text-4xl font-bold text-brand-dark max-[768px]:mb-3 max-[768px]:text-[1.8rem] max-[480px]:text-[1.6rem]">
            Featured Products & Services
          </h2>
          <p className="mx-auto max-w-[600px] text-xl text-[#666] max-[768px]:text-base max-[480px]:text-sm">
            Our most popular items trusted by bird owners everywhere
          </p>
        </div>

        <div className="mb-12 grid grid-cols-[repeat(auto-fit,minmax(300px,1fr))] gap-8 max-[768px]:mb-8 max-[768px]:grid-cols-1 max-[768px]:gap-5">
          {featuredProducts.map((product) => (
            <div
              key={product.id}
              className="relative flex flex-col overflow-hidden rounded-2xl bg-white shadow-[0_8px_25px_rgba(0,0,0,0.1)] transition-all duration-300 hover:-translate-y-1.5 hover:shadow-[0_15px_35px_rgba(0,0,0,0.15)]"
            >
              {product.badge && (
                <div
                  className={`absolute right-4 top-4 rounded-[20px] px-4 py-2 text-xs font-semibold text-white ${
                    product.badge === "Service"
                      ? "bg-brand-amber"
                      : "bg-[#e74c3c]"
                  }`}
                >
                  {product.badge}
                </div>
              )}

              <div className="relative flex h-[200px] w-full items-center justify-center overflow-hidden rounded-t-2xl max-[768px]:h-[160px] max-[480px]:h-[140px]">
                {product.isEmoji ? (
                  <span className="block text-6xl max-[768px]:text-4xl max-[480px]:text-[2rem]">
                    {product.image}
                  </span>
                ) : (
                  <img
                    src={product.image}
                    alt={product.name}
                    className="h-full w-full object-contain p-4 transition-transform duration-300 hover:scale-105"
                  />
                )}
              </div>

              <div className="flex-1 p-8 max-[768px]:p-5 max-[480px]:p-4">
                <h3 className="mb-3 text-2xl font-semibold text-brand-dark max-[768px]:mb-2 max-[768px]:text-xl max-[480px]:text-lg">
                  {product.name}
                </h3>
                <p className="mb-6 leading-relaxed text-[#666] max-[768px]:mb-4 max-[768px]:text-sm max-[480px]:text-[0.85rem]">
                  {product.description}
                </p>

                <div className="mb-6 max-[768px]:mb-4">
                  <span className="mr-3 text-2xl font-bold text-brand-amber-dark max-[768px]:text-xl max-[480px]:text-lg">
                    {product.price}
                  </span>
                  {product.originalPrice && (
                    <span className="text-lg text-[#999] line-through max-[768px]:text-base">
                      {product.originalPrice}
                    </span>
                  )}
                </div>

                <Link
                  to={product.badge === "Service" ? "/contact" : "/store"}
                  className="inline-block rounded-[25px] bg-brand-dark px-8 py-3 font-semibold text-white no-underline transition-all duration-300 hover:-translate-y-0.5 hover:bg-black max-[768px]:px-6 max-[768px]:py-2.5 max-[768px]:text-sm max-[480px]:px-5 max-[480px]:py-2 max-[480px]:text-[0.85rem]"
                >
                  {product.badge === "Service" ? "Book Now" : "Add to Cart"}
                </Link>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Link
            to="/store"
            className="inline-block rounded-[30px] border-2 border-brand-amber px-8 py-4 text-lg font-semibold text-brand-amber-dark no-underline transition-all duration-300 hover:-translate-y-0.5 hover:bg-brand-amber hover:text-black max-[768px]:px-6 max-[768px]:py-3.5 max-[768px]:text-base max-[480px]:px-5 max-[480px]:py-[0.7rem] max-[480px]:text-sm"
          >
            View All Products →
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FeaturedProducts;
